import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Media from 'react-media';
import config from './config';

const mapStateToProps = ({ responsive }) => ({
  responsive,
});

const Desktop = ({ responsive: { desktop }, children }) => (
  <Media query={`(min-width: ${config.desktop.minWidth}px)`} defaultMatches={desktop} render={() => <>{children}</>} />
);

Desktop.propTypes = {
  responsive: PropTypes.shape({
    desktop: PropTypes.bool.isRequired,
  }).isRequired,
};

export default connect(mapStateToProps)(Desktop);
